// extracted by mini-css-extract-plugin
export default {"text":"UserPassPage_text__s8Q50","subtitle":"UserPassPage_subtitle__GLSTZ"};